// Utility function to calculate 4-year costs
export const calculate4YearCosts = (form) => {
  const tuition = form.fall4YearCostTuition || 0;
  const books = form.fall4YearCostBooks || 0;
  const housing = form.fall4YearCostHousing || 0;
  const other = form.fall4YearCostOther || 0;
  const meals = form.fall4YearCostMealPlan || 0;
  return parseInt(tuition, 10) + parseInt(books, 10) + parseInt(housing, 10) + parseInt(other, 10) + parseInt(meals, 10);
};

export const calculateCosts = (form, planType = '') => {
  const suffix = planType ? planType.toUpperCase() : '';
  const tuition = form[`fall4YearCostTuition${suffix}`] || 0;
  const books = form[`fall4YearCostBooks${suffix}`] || 0;
  const housing = form[`fall4YearCostHousing${suffix}`] || 0;
  const other = form[`fall4YearCostOther${suffix}`] || 0;
  const meals = form[`fall4YearCostMealPlan${suffix}`] || 0;
  return parseInt(tuition, 10) + parseInt(books, 10) + parseInt(housing, 10) + parseInt(other, 10) + parseInt(meals, 10);
};
